<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonCreate
                        :title="$t('create_trigger')"
                        @click="
                            $router.push({
                                name: 'add_trigger',
                            })
                        "
                    >
                        {{ $t("create_trigger") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.triggers.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="tables.triggers.allFields"
                                        :activeFields.sync="
                                            tables.triggers.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.triggers.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.triggers.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.triggers.rows"
                                    :loading="tables.triggers.loading"
                                    v-bind="tables.triggers"
                                    :columnFilterValue.sync="
                                        tables.triggers.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.triggers.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.triggers
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'edit_trigger',
                                                                query: {
                                                                    uuid: tables
                                                                        .triggers
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("edit") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            clone(
                                                                tables.triggers
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            $t("clone")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        class="text-cent\er"
                                                        @click="
                                                            $router.push({
                                                                name: 'trigger_leads',
                                                                params: {
                                                                    trigger_uuid:
                                                                        tables
                                                                            .triggers
                                                                            .itemSelected
                                                                            .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("leads") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            toogleStatusTrigger(
                                                                tables.triggers
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            tables.triggers
                                                                .itemSelected &&
                                                            stringToBoolean(
                                                                tables.triggers
                                                                    .itemSelected
                                                                    .active
                                                            )
                                                                ? $t("stop")
                                                                : $t("start")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            archiveTrigger(
                                                                tables.triggers
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("archive") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            reCalculateStatisticsTrigger(
                                                                tables.triggers
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("recalculate") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'trigger_feedback_logs',
                                                                params: {
                                                                    trigger_uuid:
                                                                        tables
                                                                            .triggers
                                                                            .itemSelected
                                                                            .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t("feedback_logs")
                                                        }}
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #no-items-view>
                                        <div class="block-no-items section">
                                            <h2
                                                class="section__title text-no-items"
                                            >
                                                {{
                                                    $t(
                                                        "create_triggers_for_your_api_integrations"
                                                    )
                                                }}
                                            </h2>
                                            <CButton
                                                color="success"
                                                class="button m-2 shadow"
                                                @click="
                                                    $router.push({
                                                        name: 'add_trigger',
                                                    })
                                                "
                                            >
                                                <span class="button__icon">
                                                    <CIcon
                                                        :content="
                                                            $options.icons
                                                                .cilPlus
                                                        "
                                                    />
                                                </span>
                                                <span class="button__text">
                                                    {{ $t("add_trigger") }}
                                                </span>
                                            </CButton>
                                        </div>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="trigger.api/statistics"
                                                :table="tables.triggers"
                                            />
                                        </div>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.triggers.itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'triggers',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #active="{ item }">
                                        <td class="py-2">
                                            <CBadge
                                                v-if="item.active == '1'"
                                                color="success"
                                                class="mr-2"
                                            >
                                                {{ $t("active") }}
                                            </CBadge>
                                            <CBadge
                                                v-else
                                                color="secondary"
                                                class="mr-2"
                                            >
                                                {{ $t("stop") }}
                                            </CBadge>
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.triggers.total_pages > 0">
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.triggers.page"
                                    :pages="tables.triggers.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
    cilMediaStop,
    cilMediaPlay,
} from "@coreui/icons";
import Swal from "sweetalert2";
export default {
    name: "TriggersPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        TableSettings,
        ButtonExport,
        FilterFields,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop,
    },
    data() {
        return {
            tables: {
                triggers: {
                    fields: [
                        {
                            key: "_selected",
                            label: "#",
                            sortable: false,
                            filter: false,
                            fixed: true,
                            _filter: false,
                            active: true,
                            _style: "width:5%",
                        },
                        {
                            key: "id",
                            label: "id",
                            sorter: false,
                            filter: false,
                            _filter: true,
                            fixed: true,
                            _style: "width:10%",
                        },
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            _style: "width:20%",
                        },
                        {
                            key: "active",
                            label: "active",
                            sorter: false,
                            filter: false,
                            _filter: {
                                active: false,
                                value: null,
                                condition: "is_equal_to",
                                type: "select",
                                options: [
                                    { value: "1", label: this.$t("active") },
                                    { value: "0", label: this.$t("disable") },
                                ],
                            },
                            _style: "width:5%",
                        },
                        {
                            key: "sent",
                            label: "sent",
                            sorter: true,
                            filter: false,
                            _filter: true,
                            _style: "width:10%",
                        },
                        {
                            key: "ok",
                            label: "ok",
                            sorter: true,
                            filter: false,
                            _filter: true,
                            _style: "width:10%",
                        },
                        {
                            key: "duplicate",
                            label: "duplicate",
                            sorter: true,
                            filter: false,
                            _filter: true,
                            _style: "width:10%",
                        },
                        {
                            key: "ko",
                            label: "ko",
                            sorter: true,
                            filter: false,
                            _filter: true,
                            _style: "width:10%",
                        },
                        {
                            key: "error",
                            label: "error",
                            sorter: true,
                            filter: false,
                            _filter: true,
                            _style: "width:10%",
                        },
                        {
                            key: "created_at",
                            label: "created_at",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            _style: "width:30%",
                        },
                    ],
                    items: [],
                    order: "desc",
                    orderField: "id",
                    allFields: [],
                    rows: 5,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    _fieldNameResponseItems: "_items",
                    itemSelected: null,
                    hover: true,
                    responsive: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                },
            },
        };
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.triggers.rows = newValue;
            this.updatePagination(this.tables.triggers.page);
        },
        async updatePagination(newValue) {
            this.tables.triggers.page = newValue;
            await this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "triggers",
                url: "/trigger.api/statistics",
                adapterFilters: (filters) => {
                    filters.where = {
                        ...filters.where,
                        archive: {
                            equal: 0,
                        },
                    };
                    return filters;
                },
            });
            this.tables.triggers.itemSelected = null;
            this.tables.triggers.loading = false;
            this.updatePageLoading(false);
        },
        async toogleStatusTrigger(item) {
            try {
                await this.fetcher({
                    url:
                        "/trigger.api/toggleTriggerConfigurationActive/" +
                        item.uuid,
                    method: "PUT",
                });
                this.showMessageByMethod("PUT");
                this.updateData();
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async archiveTrigger(item) {

            const result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t("You are sure to archive this trigger?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, archive it!"),
            });
            if (result.isConfirmed) {
                try {
                    this.updatePageLoading(true);
                    await this.fetcher({
                        url: `/trigger.api/${item.uuid}/archive`,
                        method: "PUT",
                    });
                    this.showMessageByMethod("PUT");
                    this.updateData();
                } catch (error) {
                    this.showMessageError(error);
                } finally {
                    this.updatePageLoading(false);
                }
            } 
        },
        async reCalculateStatisticsTrigger(item) {
            try {
                await this.fetcher({
                    url: `/trigger.api/${item.uuid}/statistics`,
                    method: "PUT",
                    data: {
                        from: this.storeFrom,
                        to: this.storeTo,
                    },
                });
                this.showMessageByMethod("PUT");
                this.updateData();
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async clone(item) {

            const result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t("You are sure to clone this trigger?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, clone it!"),
            });
            if (result.isConfirmed) {

                try {
                    this.updatePageLoading(true);
                    let response = await this.fetcher({
                        url: "/trigger.api/triggerConfiguration/" + item.uuid,
                        method: "GET",
                    });

                    let cloneTrigger = response._items;
                    cloneTrigger.name = cloneTrigger.name + " COPY";
                    cloneTrigger.action_settings = JSON.parse(
                        cloneTrigger.action_settings
                    );
                    cloneTrigger.event_execute_conditions = JSON.parse(
                        cloneTrigger.event_execute_conditions
                    );
                    cloneTrigger.acceptance_filters = JSON.parse(
                        cloneTrigger.acceptance_filters
                    );

                    cloneTrigger.active = false;

                    response = await this.fetcher({
                        url: "/trigger.api/triggerConfiguration",
                        method: "POST",
                        data: cloneTrigger,
                    });
                    this.showMessageByMethod("POST");
                    this.updateData();
                } catch (error) {
                    this.showMessageError(error);
                } finally {
                    this.updatePageLoading(false);
                }
            }
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
.plataform__img {
    height: 5em !important;
    width: auto;
}
</style>
